/**
 * Navigation content explaining Article 51 information.
 */
import { Box, Button, Typography } from "@mui/material";
import { useConfigurations } from "../../../../context/ConfigurationsContext/ConfigurationsContext";

type Article51Props = {
  paymentMode?: boolean;
};

const Article51 = ({ paymentMode = false }: Article51Props) => {
  const { txt, currentlenguage } = useConfigurations();
  const text = txt[currentlenguage];

  const paragraph1 = `${text[167]}`;
  const paragraph2 = `${text[168]}`;
  const paragraph3 = `${text[169]}`;
  const paragraph4 = `${text[170]}`;
  const paragraph5 = `${text[171]}`;
  const linkText = `${text[172]}`;

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          ...(paymentMode
            ? {
                alignItems: "center",
                bgcolor: "#F6F6F6",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: { xs: "flex-start", md: "center" },
                minHeight: "100%",
                overflowY: "auto",
                position: "relative",
                px: { xs: 1.5, md: 2 },
                width: "100%",
                maxWidth: "100%",
                zIndex: 1,
              }
            : {
                alignItems: "center",
                bgcolor: "white",
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                justifyContent: "center",
                left: 0,
                overflowY: "auto",
                position: "fixed",
                px: 2,
                top: 0,
                width: "100%",
                zIndex: 10,
              }),
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            gap: { xs: "8px", md: "10px" },
            justifyContent: { xs: "flex-start", md: "flex-end" },
            maxWidth: "664px",
            pb: { xs: "108px", md: 0 },
            pt: { xs: "96px", md: 0 },
            width: "100%",
          }}
        >
          <Box sx={{ margin: "0 auto", maxWidth: { xs: "320px", md: "100%" }, textAlign: "center", width: "100%" }}>
            <Typography
              sx={{
                color: "#761542",
                fontFamily: "Candara",
                fontSize: { xs: "24px", md: "28px" },
                fontWeight: 700,
                lineHeight: { xs: "28px", md: "30px" },
              }}
            >
              State Law Obligations for International Visitors
            </Typography>
            <Typography
              sx={{
                color: "#4197A8",
                fontFamily: "Candara",
                fontSize: { xs: "24px", md: "18px" },
                fontWeight: 700,
                lineHeight: { xs: "28px", md: "20px" },
              }}
            >
              According to Article 51
            </Typography>
          </Box>

          <Box sx={{ color: "#232323", maxWidth: { xs: "320px", md: "564px" }, width: "100%" }}>
            <Typography
              sx={{ fontFamily: "Candara", fontSize: { xs: "13px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "16px", md: "20px" }, mb: 1.5 }}
              dangerouslySetInnerHTML={{ __html: paragraph1 }}
            />
            <Typography
              sx={{ fontFamily: "Candara", fontSize: { xs: "13px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "16px", md: "20px" }, mb: 1.5 }}
            >
              <Box component="span" sx={{ fontWeight: 700 }}>
                NOTICE:
              </Box>{" "}
              {paragraph2}
            </Typography>
            <Typography
              sx={{ fontFamily: "Candara", fontSize: { xs: "13px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "16px", md: "20px" }, mb: 1.5 }}
              dangerouslySetInnerHTML={{ __html: paragraph3 }}
            />
            <Typography sx={{ fontFamily: "Candara", fontSize: { xs: "13px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "16px", md: "20px" }, mb: 1.5 }}>
              {paragraph4}
            </Typography>
            <Typography sx={{ fontFamily: "Candara", fontSize: { xs: "13px", md: "16px" }, fontWeight: 400, lineHeight: { xs: "16px", md: "20px" } }}>
              {paragraph5}
            </Typography>
          </Box>

          <Button
            variant="outlined"
            href="https://documentos.congresoqroo.gob.mx/leyes/L195-XVIII-20250110-L1820250110089.pdf"
            target="_blank"
            rel="noopener"
            sx={{
              alignSelf: "center",
              border: "1.5px solid #943663",
              borderRadius: "24px",
              color: "#943663",
              fontFamily: "Candara",
              fontSize: { xs: "11px", md: "12px" },
              fontWeight: 700,
              height: "32px",
              minWidth: { xs: "124px", md: "175px" },
              px: "12px",
              mb: { xs: 2, md: 0 },
              py: "8px",
              textTransform: "none",
            }}
          >
            {linkText || "View full article"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Article51;
